// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"login_loginWrapper__3oB_T","loginBoxWrapper":"login_loginBoxWrapper__39sTy"};